import { Box, IStackProps } from 'native-base';
import React, { ReactNode } from 'react';

import AspectImage from 'app/components/AspectImage';
import { cdn } from 'app/utils/image';

export type TicketLogoProps = IStackProps & {
  children?: ReactNode;
  logo?: Maybe<{ url: string }>;
};

export default function TicketLogo({ children, logo, ...props }: TicketLogoProps) {
  return (
    <Box testID="TicketLogo" {...props}>
      {!!logo?.url && (
        <AspectImage
          alt="Product Logo"
          ratio={2.14}
          url={cdn(logo.url ?? '', [['output', { format: 'png', density: 400 }]])}
          w="full"
        />
      )}
    </Box>
  );
}
